import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/representante-autorizado-de-suiza-ch-rep")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/representante-autorizado-de-suiza-ch-rep"),
  component: RegulatoryOffering,
});

